import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appPasswordVisibility]',
  standalone: true
})
export class PasswordVisibilityDirective {
  private _shown = false;

  constructor(private el: ElementRef) {
    this.setup();
  }

  toggle(div: HTMLElement) {
    this._shown = !this._shown;
    div.className = "hide-show-pwd-icon";

    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      div.innerHTML = '<span class="e-icon icon-view--off--filled icon-password-visibilty"></span>';
      div.title = "Hide Password";
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      div.innerHTML = '<span class="e-icon icon-view--filled icon-password-visibilty"></span>';
      div.title = "Show Password";
    }
  }

  setup() {
    const parent = this.el.nativeElement.parentNode;
    const inputLabel = parent.getElementsByTagName('LABEL')[0];

    var divFlex = document.createElement('div');
    divFlex.append(this.el.nativeElement);
    divFlex.className = "flex-container";
    var div = document.createElement('div');
    div.className = "hide-show-pwd-icon";

    div.innerHTML = '<span class="e-icon icon-view--filled icon-password-visibilty"></span>';
    div.title = "Show Password";
    div.addEventListener('click', (event) => {
      this.toggle(div);
    });
    divFlex.appendChild(div);


    if (parent.getElementsByTagName('LABEL').length) {
      parent.append(parent.getElementsByTagName('label')[0]);
      if (parent.getElementsByTagName('SPAN').length)
        parent.append(parent.getElementsByTagName('span')[0]);

      parent.appendChild(divFlex);
    }
    else {
      parent.append(divFlex);
    }
  }
}
